import type { ProductCategory } from '@/types/SearchAPI/SAPIProduct'
import { error } from '@/services/Log'
import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'

type SkuChangeReactor<T = void> = (
  name: string,
  category: readonly ProductCategory[],
  variantId: string | number,
  price: string | number,
) => T

const skuChangeReactor: SkuChangeReactor<Promise<void>> = async (
  name, category, variantId, price,
) => {
  try {
    // google ads
    window.gtag?.('event', 'view_item', {
      value: price,
      items: [{
        item_id: String(variantId),
        item_name: name,
        google_business_vertical: 'retail',
      }],
      currency: 'USD',
    })
  } catch (err) {
    error('MarketingChannels error:', err)
  }

  try {
    // Pinterest
    if (typeof window.pintrk === 'function') {
      const [{ getCategoryName }] = await allPromisesWithRetries(() => [import('@/helpers/getCategoryName')])
      const categoryName = getCategoryName(category)
      window.pintrk('track', 'pagevisit', {
        line_items: [{
          product_id: variantId,
          product_category: categoryName,
        }],
      })
    }
  } catch (err) {
    error('MarketingChannels error', err)
  }
}

const onSkuChange: SkuChangeReactor = (
  name: string,
  category: readonly ProductCategory[],
  variantId: string | number,
  price: string | number,
) => {
  setTimeout(() => {
    skuChangeReactor(name, category, variantId, price).catch(error)
  }, 500)
}
const MarketingChannels = {
  onSkuChange,
}

export default MarketingChannels
